import { getData, postData, putData } from 'src/api/http.service';
import { handleApiError, handleApiSuccess, getAPIEndpoints } from 'src/utils/general.utils';

import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

const BatchManagementActions = {
  BATCH_LIST_SUCCESS: '[API] : Get batch list action.',
  BRANCH_LIST_SUCCESS: '[API] : Get branch list action.',
  PROGRAM_LIST_SUCCESS: '[API] : Get program list action.',
  ADD_NEW_BRANCH_SUCCESS: '[API] : Add new branch action',
  ADD_NEW_PROGRAM_SUCCESS: '[API] : Add new program action',
  ADD_NEW_BATCH_SUCCESS: '[API] : Add new batch action',
  UPDATE_BATCH_SUCCESS: '[API] : Update batch action',
  CLOSE_BATCH_SUCCESS: '[API] : Close batch action',
  RESET_CREATE_BATCH_SUCCESS: 'RESET_CREATE_BATCH_SUCCESS',
  BATCH_DETAILS_SUCCESS: '[API] : Get batch details action.',
  UPLOAD_STUDENTS_SUCCESS: '[API] : Upload students action.',
  STUDENTS_LIST_SUCCESS: '[API] : Get students list saction.',
  UPDATE_BATCH_OF_STUDENTS: '[API] : Update batch of students action.',
  ADD_NEW_GROUP_SUCCESS: '[API] : Add new group action',
  GROUP_LIST_SUCCESS: '[API] : Get group list action.',
};

/*
    Plain Actions
*/
function BatchListSuccessAction(payload) {
  return {
    type: BatchManagementActions.BATCH_LIST_SUCCESS,
    payload,
  };
}
function BatchDetailsSuccessAction(payload) {
  return {
    type: BatchManagementActions.BATCH_DETAILS_SUCCESS,
    payload,
  };
}
function AddNewBatchSuccessAction(payload) {
  return {
    type: BatchManagementActions.ADD_NEW_BATCH_SUCCESS,
    payload,
  };
}
function ResetCreateBatcSuccesshAction() {
  return {
    type: BatchManagementActions.RESET_CREATE_BATCH_SUCCESS,
  };
}
function UpdateBatchSuccessAction(payload) {
  return {
    type: BatchManagementActions.UPDATE_BATCH_SUCCESS,
    payload,
  };
}
function CloseBatchSuccessAction(payload) {
  return {
    type: BatchManagementActions.CLOSE_BATCH_SUCCESS,
    payload,
  };
}
function BranchListSuccessAction(payload) {
  return {
    type: BatchManagementActions.BRANCH_LIST_SUCCESS,
    payload,
  };
}
function AddNewBranchSuccessAction(payload) {
  return {
    type: BatchManagementActions.ADD_NEW_BRANCH_SUCCESS,
    payload,
  };
}
function ProgramListSuccessAction(payload) {
  return {
    type: BatchManagementActions.PROGRAM_LIST_SUCCESS,
    payload,
  };
}
function AddNewProgramSuccessAction(payload) {
  return {
    type: BatchManagementActions.ADD_NEW_PROGRAM_SUCCESS,
    payload,
  };
}
function UploadStudetsSuccessAction(payload) {
  return {
    type: BatchManagementActions.UPDATE_BATCH_OF_STUDENTS,
    payload,
  };
}
function StudetsSuccessAction(payload) {
  return {
    type: BatchManagementActions.STUDENTS_LIST_SUCCESS,
    payload,
  };
}
function UpdateBatchStudetsSuccessAction(payload) {
  return {
    type: BatchManagementActions.UPDATE_BATCH_OF_STUDENTS,
    payload,
  };
}
function AddNewGroupSuccessAction(payload) {
  return {
    type: BatchManagementActions.ADD_NEW_GROUP_SUCCESS,
    payload,
  };
}
function GroupListSuccessAction(payload) {
  return {
    type: BatchManagementActions.GROUP_LIST_SUCCESS,
    payload,
  };
}
/*
    Async Actions
*/
function GetBatchListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      if (response.data.data.batchDTOS) {
        dispatch(BatchListSuccessAction(response.data.data.batchDTOS));
      }
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      return true;
    } catch (err) {
      dispatch(BatchListSuccessAction([]));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
function GetBatchdetailsByBatchId(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(BatchDetailsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      return true;
    } catch (err) {
      dispatch(BatchDetailsSuccessAction({}));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
function CreateNewBatchAction(url, payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, payload, headers);
      dispatch(AddNewBatchSuccessAction(response.data));
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      } else {
        dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
        dispatch(GetBatchListAction(getAPIEndpoints().getBatchList));
      }
      return { status: true, apiRes: response };
    } catch ({ response }) {
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      }
    }
  };
}
function UpdateBatchAction(url, payload, headers) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, payload, headers);
      dispatch(UpdateBatchSuccessAction(response.data));
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      } else {
        dispatch(ApiCallSuccessAction(handleApiSuccess(response)));
        dispatch(GetBatchListAction(getAPIEndpoints().getBatchList));
      }
      return { status: true, apiRes: response };
    } catch ({ response }) {
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      }
    }
  };
}
function CloseBatchAction(url, payload, headers) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, payload, headers);
      dispatch(CloseBatchSuccessAction(response.data));
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      } else {
        dispatch(ApiCallSuccessAction(handleApiSuccess(response.data.data)));
        dispatch(GetBatchListAction(getAPIEndpoints().getBatchList));
      }
      return { status: true, apiRes: response };
    } catch ({ response }) {
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      }
    }
  };
}
function GetBranchListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(BranchListSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      return true;
    } catch (err) {
      dispatch(BranchListSuccessAction([]));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
function CreateNewBranchAction(payload, data, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(payload, data, headers);
      dispatch(AddNewBranchSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      dispatch(GetBranchListAction(getAPIEndpoints().getBranchList));
      return { status: true, data: response.data.data };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return { status: false, apiRes: handleApiError(err) };
    }
  };
}
function GetProgramListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      if (response.data.data && response.data.data.length > 0) {
        dispatch(ProgramListSuccessAction(response.data.data));
      } else {
        dispatch(ProgramListSuccessAction([]));
      }
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      return true;
    } catch (err) {
      dispatch(ProgramListSuccessAction([]));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
function CreateNewProgramAction(payload, data, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(payload, data, headers);
      dispatch(AddNewProgramSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return { status: true, data: response.data.data };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return { status: false, apiRes: handleApiError(err) };
    }
  };
}
function UploadStudents(url, payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, payload, headers);
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      } else {
        dispatch(UploadStudetsSuccessAction(response.data));
        dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      }
      return { status: true, apiRes: response };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return { status: false, apiRes: handleApiError(err) };
    }
  };
}
function GetStudentsListAction(url, headers) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      if (
        response.data &&
        response.data.data &&
        response.data.data &&
        response.data.data.studentIds.length > 0
      ) {
        dispatch(
          GetStudentsListbyStudentIdsAction(
            getAPIEndpoints().getStudentsListByStudentIds,
            response.data.data
          )
        );
      } else {
        dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
        dispatch(StudetsSuccessAction({ data: [] }));
      }
      return true;
    } catch (err) {
      dispatch(StudetsSuccessAction({ data: [] }));
      return false;
    }
  };
}
function GetStudentsListbyStudentIdsAction(url, payload, headers) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, payload, headers);
      dispatch(StudetsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      return true;
    } catch (err) {
      dispatch(StudetsSuccessAction({ data: [] }));
      return false;
    }
  };
}
function UpdateBatchOfStudentsAction(url, payload, headers) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, payload, headers);
      dispatch(UpdateBatchStudetsSuccessAction(response.data));
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      } else {
        if (response.data && response.data.data && response.data.data.length > 0) {
          response.data.data.map(d =>
            dispatch(
              ApiCallFailedAction(handleApiError(d.name ? `For ${d.name} ${d.reason}` : d.reason))
            )
          );
        } else {
          dispatch(ApiCallSuccessAction(handleApiSuccess(response)));
        }
        dispatch(
          GetStudentsListAction(
            getAPIEndpoints().getStudentsListByBatch.replace('{batchId}', payload.oldBatchId)
          )
        );
      }
      return { status: true, apiRes: response };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return { status: false, apiRes: handleApiError(err) };
    }
  };
}
function ResetCreateBatchAction() {
  return dispatch => {
    dispatch(ResetCreateBatcSuccesshAction());
  };
}
function CreateNewGroupAction(url, payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, payload, headers);
      dispatch(AddNewGroupSuccessAction(response.data));
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      } else {
        dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      }
      return { status: true, apiRes: response };
    } catch ({ response }) {
      if (response.data && response.data.error) {
        dispatch(ApiCallFailedAction(handleApiError(response.data.message)));
      }
    }
  };
}
function GetGroupListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      if (response.data.data) {
        dispatch(GroupListSuccessAction(response.data.data));
      }
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      return true;
    } catch (err) {
      dispatch(GroupListSuccessAction([]));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export {
  GetBatchListAction,
  GetBranchListAction,
  GetProgramListAction,
  CreateNewBatchAction,
  UpdateBatchAction,
  CreateNewBranchAction,
  CreateNewProgramAction,
  CloseBatchAction,
  BatchManagementActions,
  ResetCreateBatchAction,
  GetBatchdetailsByBatchId,
  UploadStudents,
  GetStudentsListAction,
  UpdateBatchOfStudentsAction,
  CreateNewGroupAction,
  GetGroupListAction,
};
